import type { HealthSubjectType } from '../../../ui-foundation/features/health';

export type ReminderType =
  | 'gp'
  | 'dentist'
  | 'optician'
  | 'smear'
  | 'mammogram'
  | 'health-check'
  | 'prostate'
  | 'hrt-review'
  | 'blood-test'
  | 'medication'
  | 'vaccination'
  | 'other';

export interface HealthReminder {
  id: string;
  user_id: string;
  type: ReminderType;
  title: string;
  due_date: string | null;
  due_time?: string | null;
  frequency_months: number | null;
  notes: string | null;
  completed_at: string | null;
  created_at: string;
  reminder_days_before?: number | null;
  subject_type?: string;
  subject_id?: string | null;
  subject_name?: string | null;
  recurrence_type?: string;
  recurrence_interval?: number | null;
  recurrence_unit?: string | null;
  recurrence_day_of_week?: number[] | null;
  recurrence_week_of_month?: string | null;
  recurrence_month_day?: number | null;
}

export type HealthSubjectOption = {
  value: string;
  label: string;
  subjectType: HealthSubjectType;
  subjectId: string | null;
  subjectName: string;
  subtitle: string;
};

export const TYPE_ICONS: Record<ReminderType, string> = {
  gp: '🩺',
  dentist: '🦷',
  optician: '👁',
  smear: '🩺',
  mammogram: '🎗️',
  'health-check': '📋',
  prostate: '🧬',
  'hrt-review': '🌿',
  'blood-test': '🩸',
  medication: '💊',
  vaccination: '💉',
  other: '📋',
};

export const TYPE_LABELS: Record<ReminderType, string> = {
  gp: 'GP',
  dentist: 'Dental check-up',
  optician: 'Opticians check-up',
  smear: 'Cervical screening',
  mammogram: 'Breast screening',
  'health-check': 'NHS Health Check',
  prostate: 'Prostate / PSA',
  'hrt-review': 'HRT review',
  'blood-test': 'Blood test',
  medication: 'Medication',
  vaccination: 'Vaccination',
  other: 'Other',
};
